<!-- src/views/VideoPage.vue -->
<template>
  <!-- 页面根容器，保持与您其他页面一致的布局和样式 -->
  <div class="min-h-screen font-sans bg-white">
    <Header class="bg-gray-100" />
    <div class="flex flex-col items-center px-4 py-8 font-sans">
      <!-- 主要内容区域 -->
      <main class="flex-1 px-4 py-8 w-full max-w-7xl">
        <!-- 视频标题和描述 -->
        <div class="mb-8 text-center">
          <h1 class="mb-2 text-2xl font-semibold text-black sm:text-3xl">
            Product Support Videos: {{ selectedProductName }}
          </h1>
          <p class="text-gray-600">
            Explore setup guides, feature tutorials, and helpful tips for your
            product.
          </p>
        </div>

        <!-- 视频播放器区域 -->
        <!-- vue-plyr 组件会自动创建一个功能丰富的播放器 -->
        <section
          class="mb-10"
          v-for="(productVideos, productName) in filteredVideos"
          :key="productName"
        >
          <!-- <h2 class="mb-4 text-xl font-semibold text-black">
            {{ productName }}
          </h2> -->
          <div class="video-grid">
            <article
              class="overflow-hidden bg-black rounded-lg border border-gray-200 shadow-md"
              v-for="videoItem in productVideos"
              :key="videoItem.vedio"
            >
              <div class="video-player">
                <vue-plyr ref="plyr" :options="plyrOptions">
                  <video
                    controls
                    crossorigin
                    playsinline
                    :poster="videoItem.cover"
                  >
                    <source
                      size="720"
                      :src="videoItem.vedio"
                      type="video/mp4"
                    />
                    <source
                      size="1080"
                      :src="videoItem.vedio"
                      type="video/mp4"
                    />
                    <track
                      kind="captions"
                      label="English"
                      srclang="en"
                      src="https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.en.vtt"
                      default
                    />
                  </video>
                </vue-plyr>
              </div>
            </article>
          </div>
        </section>

        <!-- 相关信息或操作区域 -->
        <div class="pt-8 mt-8 text-left text-gray-800 border-t border-gray-200">
          <!-- <h3 class="mb-4 text-xl font-semibold">Related Information</h3>
                <ul class="space-y-2 list-disc list-inside">
                <li>
                    <a href="#" class="font-medium text-rose-500 hover:underline">View ELEPHAS K350 Product Page</a>
                </li>
                <li>
                    <a href="#" class="font-medium text-rose-500 hover:underline">Read the Setup Guide (PDF)</a>
                </li>
                <li>
                    <a href="/pre-sales-questions" class="font-medium text-rose-500 hover:underline">Back to Pre-sales Questions</a>
                </li>
                </ul> -->
        </div>
      </main>
    </div>
    <!-- 统一的页脚 (根据您的项目结构，您可以取消注释) -->
    <!-- <FooterComponent class="mt-12" /> -->
  </div>
</template>

<script>
// 如果您将页脚组件化，可以在此导入
import Header from "@/components/header";
// import FooterComponent from '@/components/footer.vue'

export default {
  name: "VideoPlayerPage",
  components: {
    Header,
  },
  data() {
    return {
      // Plyr 播放器的配置选项
      // 您可以在这里自定义播放器功能，例如：
      // controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
      plyrOptions: {
        // 在此添加自定义配置
        // 留空则使用默认配置，已经非常友好
        // 比如，设置主题色来匹配您的品牌
        // 这需要您在全局 CSS 中定义 CSS 变量
        // 例如：:root { --plyr-color-main: #dd6464; }
      },
      videos: {
        Q4: [
          {
            vedio:
              "https://cdn.elephas-direct.com/socheerfull-service/vedio/alexa.mp4",
            cover:
              "https://cdn.elephas-direct.com/socheerfull-service/vedio/alexa.png",
          },
          {
            vedio:
              "https://cdn.elephas-direct.com/socheerfull-service/vedio/share.mp4",
            cover:
              "https://cdn.elephas-direct.com/socheerfull-service/vedio/share.png",
          },
          {
            vedio:
              "https://cdn.elephas-direct.com/socheerfull-service/vedio/conn.mp4",
            cover:
              "https://cdn.elephas-direct.com/socheerfull-service/vedio/conn.png",
          },
        ],
      },
    };
  },
  computed: {
    selectedProductName() {
      const productNames = Object.keys(this.videos);
      const routeProductName = this.$route.params.productName;

      if (!routeProductName) {
        return productNames[0] || "";
      }

      return (
        productNames.find(
          (productName) =>
            productName.toLowerCase() === routeProductName.toLowerCase(),
        ) || ""
      );
    },
    filteredVideos() {
      if (!this.selectedProductName) {
        return {};
      }

      return {
        [this.selectedProductName]: this.videos[this.selectedProductName],
      };
    },
    // 获取播放器实例
    player() {
      return this.$refs.plyr.player;
    },
  },
  mounted() {
    // 配置同时只能有一个视频播放
    this.$nextTick(() => {
      const players = this.$refs.plyr;
      if (players && players.length) {
        players.forEach((plyrComponent, index) => {
          const player = plyrComponent.player;
          if (player) {
            player.on("play", () => {
              // 当前视频开始播放时，暂停其他所有视频
              players.forEach((otherPlyrComponent, otherIndex) => {
                if (otherIndex !== index) {
                  const otherPlayer = otherPlyrComponent.player;
                  if (otherPlayer && !otherPlayer.paused) {
                    otherPlayer.pause();
                  }
                }
              });
            });
          }
        });
      }
    });
  },
};
</script>

<style>
.video-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.5rem;
}

.video-player {
  aspect-ratio: 16 / 9;
  background: #000;
}

.video-player .plyr,
.video-player .plyr__video-wrapper,
.video-player video {
  width: 100%;
  height: 100%;
}

@media (max-width: 1023px) {
  .video-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 639px) {
  .video-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* 
  可选：如果您想让播放器的主题色与您的品牌红色一致，
  可以在您的全局 CSS 文件 (如 src/assets/tailwind.css) 中添加以下代码。
  这将覆盖 Plyr 的默认蓝色主题。
*/
/*
:root {
  --plyr-color-main: #dd6464;
}
*/
</style>
